module.exports = __webpack_public_path__ + "img/back_right.311298f9.png";